import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { DynamicDialogRef, DialogService, DynamicDialogComponent, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FbAuctionDetailConfiguration } from './fb-auction-detail.configuration';
import { FbSellerInfoConfiguration } from '../fb-seller-info/fb-seller-info.configuration';
import { AuctionDetailButtonConfiguration } from './auction-detail-button/auction-detail-button.configuration';
import { FbGeneralButtonConfiguration } from '../fb-general-button/fb-general-button.configuration';
import { FbBatchsubmitModalComponent } from '../fb-batchsubmit-modal/fb-batchsubmit-modal.component';
import { FbSubmitModalConfiguration } from '../fb-batchsubmit-modal/fb-batchsubmit-modal.component.configuration';
import { PnInputControlConfiguration } from '../controls/pn-input-control/pn-input-control.configuration';
import { UserService } from 'src/app/_core/lib/user.service';
import { RankingBidDTO, RankingController } from 'src/app/_core/controllers/ranking.controller';
import { BatchController } from 'src/app/_core/controllers/batch.controller';
import { BatchDTO } from 'src/app/_core/classes/BatchDTO';
import { ReachedPlaceDTO } from 'src/app/_core/classes/ReachedPlacesDTO';
import { BatchStatusEnum } from 'src/app/_core/enums/batch-status.enum';
import { MeasuringUnitEnum } from 'src/app/_core/classes/BatchPreviewDTO';
import { Timer } from 'src/app/_core/enums/timer.enum';
import { IAddress } from 'src/app/pages/auction/create-auction/step1/step1.component';

export enum AuctionTypeEnum {
    ActiveCustomer = 1,
    Customer = 2,
    Seller = 3
}

@Component({
    selector: 'fb-auction-detail',
    templateUrl: './fb-auction-detail.component.html',
    styleUrls: ['./fb-auction-detail.component.scss']
})
export class FbAuctionDetailComponent implements OnInit {

    // Template References
    @ViewChild('auctionCard') auctionCard: ElementRef;

    // Outputs
    @Output() bidSubmitted = new EventEmitter<number>();

    // Timer Options
    timer = [
        { label: '5 minuti', value: Timer.MIN5 },
        { label: '10 minuti', value: Timer.MIN10 },
        { label: '15 minuti', value: Timer.MIN15 },
        { label: '30 minuti', value: Timer.MIN15 },
        { label: '1 ore', value: Timer.H1 },
        { label: '6 ore', value: Timer.H6 },
        { label: '12 ore', value: Timer.H12 },
    ];

    // Configuration
    instance: DynamicDialogComponent;
    configuration: FbAuctionDetailConfiguration;
    localBatch: any; // Copia locale dei dati batch

    // Component Configurations
    sellerConfiguration: FbSellerInfoConfiguration;
    priceButtonConfiguration: AuctionDetailButtonConfiguration;
    timeButtonConfiguration: AuctionDetailButtonConfiguration;
    bidButtonConfiguration: AuctionDetailButtonConfiguration;
    positionButtonConfiguration: AuctionDetailButtonConfiguration;
    submitButtonConfiguration: FbGeneralButtonConfiguration;
    delateButtonConfiguration: FbGeneralButtonConfiguration;
    suspendButtonConfiguration: FbGeneralButtonConfiguration;
    extraCSSButtonConfiguration: FbGeneralButtonConfiguration;
    bidInputConfiguration: PnInputControlConfiguration;

    // Forms
    form: FormGroup;
    formSusp: FormGroup;

    // State
    detailAuctionType: AuctionTypeEnum | null = null;
    addPrice: number = 0.00;
    currentOffer: number;
    showBidForm: boolean = false;
    suspendeBatchForm: boolean = false;
    isLoading: boolean = false;

    // Data
    Places: Array<ReachedPlaceDTO> = [];
    address: IAddress[] = [];
    today: Date;
    date: Date;
    selectedTimer: any;

    constructor(
        private formBuilder: FormBuilder,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public userService: UserService,
        public dialogService: DialogService,
        private messageService: MessageService,
        private cdr: ChangeDetectorRef,
        public rankingController: RankingController,
        public batchController: BatchController
    ) {
        this.configuration = this.config.data.configuration;
        this.initializeForms();
    }

    // Computed Properties
    get multipleBatch(): boolean {
        return this.localBatch.Quantity > 1;
    }

    // Lifecycle Hooks
    async ngOnInit(): Promise<void> {
        await this.loadCompleteData();
    }

    // Main Data Loading Method
    private async loadCompleteData(keepFormOpen: boolean = false): Promise<void> {
        try {
            console.log('🔄 Loading complete data...');

            // Carica i dati completi dal backend
            const freshBatch = await this.batchController.getBatchInfo(this.configuration.batch.Oid);
            this.localBatch = freshBatch;

            console.log('📦 Fresh batch loaded:', this.localBatch);
            console.log('💰 RankingInfos:', this.localBatch.RankingInfos);

            // Inizializza tutto con i dati freschi
            this.today = new Date();
            this.processPlaces();
            this.initializeCustomerOffer();
            this.initializeBidInput();
            this.setup();
            this.setupSellerInfo();
            this.setupPriceButton();
            this.setupTimeButton();

            // IMPORTANTE: Resetta il form di offerta dopo aver ricaricato i dati
            this.resetBidFormAfterReload(keepFormOpen);

            console.log('✅ Load complete data finished');

        } catch (error) {
            console.error('❌ Error loading batch data:', error);
            // Fallback ai dati della configurazione
            this.localBatch = { ...this.configuration.batch };
            this.initializeCustomerOffer();
            this.initializeBidInput();
            this.setup();
            this.setupSellerInfo();
            this.setupPriceButton();
            this.setupTimeButton();
        }
    }

    // Nuovo metodo specifico per il reset dopo reload
    private resetBidFormAfterReload(keepFormOpen: boolean = false): void {
        if (!this.userService.roleChecker.is.customer()) {
            console.log('⏭️ Skip reset - not a customer');
            return;
        }

        const myAmount = this.localBatch.RankingInfos?.MyAmount;

        console.log('🔄 Reset Bid Form - MyAmount:', myAmount);
        console.log('🔄 Keep form open:', keepFormOpen);

        // Aggiorna i valori per la nuova offerta con i dati freschi
        if (myAmount && myAmount > 0) {
            this.addPrice = 0.50;
            this.currentOffer = myAmount + this.addPrice;
            console.log('✅ New offer set to:', this.currentOffer);
        } else {
            this.addPrice = 0.00;
            this.currentOffer = this.localBatch.StartingPrice;
            console.log('✅ First offer set to:', this.currentOffer);
        }

        // Chiudi il form di bid solo se non vogliamo mantenerlo aperto
        if (!keepFormOpen && this.showBidForm) {
            this.showBidForm = false;
            console.log('🚪 Bid form closed');
        } else if (keepFormOpen) {
            console.log('📌 Bid form kept open');
        }

        // IMPORTANTE: Forza Angular a rilevare i cambiamenti
        this.cdr.detectChanges();
        console.log('🔄 Change detection triggered');
    }

    // Initialization Methods
    private initializeCustomerOffer(): void {
        if (!this.userService.roleChecker.is.customer()) {
            return;
        }

        const myAmount = this.localBatch.RankingInfos?.MyAmount;

        if (myAmount === null || myAmount === 0) {
            this.currentOffer = this.localBatch.StartingPrice;
        } else {
            this.currentOffer = myAmount;
            this.addPrice = 0.50;
            this.currentOffer = myAmount + this.addPrice;
        }
    }

    private initializeBidInput(): void {
        const totalBids = this.localBatch.RankingInfos?.TotalBids;

        if (totalBids > 0) {
            this.bidInputConfiguration = PnInputControlConfiguration
                .create('Indica il nr. di Lotti per cui vuoi rilanciare', 'number', 'bid')
                .setControl(new FormControl(totalBids, [
                    Validators.min(totalBids),
                    Validators.max(this.localBatch.Quantity)
                ]));
        } else {
            this.bidInputConfiguration = PnInputControlConfiguration
                .create('Indica il nr. di Lotti per cui vuoi fare l\'offerta', 'number', 'bid')
                .setControl(new FormControl(1, [
                    Validators.min(1),
                    Validators.max(this.localBatch.Quantity)
                ]));
        }
    }

    private initializeForms(): void {
        this.form = this.formBuilder.group({
            Address: [null, Validators.required],
        });

        this.formSusp = this.formBuilder.group({
            date: [null, Validators.required],
            timer: [null, Validators.required],
        });
    }

    // Setup Methods
    private setup(): void {
        this.determineAuctionType();
        this.setupByAuctionType();
        this.updateTimeDisplay();
    }

    private determineAuctionType(): void {
        if (this.userService.roleChecker.is.customer()) {
            this.detailAuctionType = this.localBatch.RankingInfos?.TotalBids > 0
                ? AuctionTypeEnum.ActiveCustomer
                : AuctionTypeEnum.Customer;
        } else {
            this.detailAuctionType = AuctionTypeEnum.Seller;
        }
    }

    private setupByAuctionType(): void {
        switch (this.detailAuctionType) {
            case AuctionTypeEnum.ActiveCustomer:
                this.setupActiveCustomer();
                break;
            case AuctionTypeEnum.Customer:
                this.setupCustomer();
                break;
            case AuctionTypeEnum.Seller:
                this.setupSeller();
                break;
        }
    }

    private setupActiveCustomer(): void {
        this.submitButtonConfiguration = FbGeneralButtonConfiguration
            .create("RILANCIA", () => this.toggleBidForm())
            .setStyleClass("secondary-color");

        if (this.localBatch.Status === BatchStatusEnum.Closed) {
            this.submitButtonConfiguration.setDisabled(true);
        }
    }

    private setupCustomer(): void {
        this.submitButtonConfiguration = FbGeneralButtonConfiguration
            .create("PARTECIPA", () => this.toggleBidForm())
            .setStyleClass("secondary-color");

        if (this.localBatch.Status === BatchStatusEnum.Closed) {
            this.submitButtonConfiguration.setDisabled(true);
        }
    }

    private setupSeller(): void {
        if (this.localBatch.Status === BatchStatusEnum.Closed) {
            this.delateButtonConfiguration = FbGeneralButtonConfiguration
                .create("CANCELLA")
                .setSeverity("danger")
                .setPosIcon("right")
                .setIcon("pi pi-trash");

            this.suspendButtonConfiguration = FbGeneralButtonConfiguration
                .create("RIPUBBLICA")
                .setPosIcon("right")
                .setIcon("pi pi-clock");
        } else {
            if (this.localBatch.Status === BatchStatusEnum.Approval) {
                return;
            }

            this.delateButtonConfiguration = FbGeneralButtonConfiguration
                .create("ANNULLA", () => this.onDelete())
                .setSeverity("danger")
                .setPosIcon("right")
                .setIcon("pi pi-trash");

            this.suspendButtonConfiguration = FbGeneralButtonConfiguration
                .create("POSPONI", () => this.suspendForm())
                .setPosIcon("right")
                .setIcon("pi pi-clock");
        }
    }

    private processPlaces(): void {
        this.Places = this.localBatch?.ReachedPlaces || [];

        if (this.Places.length > 0) {
            this.address = this.Places.map(place => ({
                label: `${place.Name}, ${place.City}, ${place.PostalCode}`,
                value: place.Oid
            }));

            if (this.Places.length === 1) {
                this.form.patchValue({ Address: this.address });
            }
        }
    }

    private setupSellerInfo(): void {
        if (this.localBatch.CreatedBy) {
            this.sellerConfiguration = FbSellerInfoConfiguration
                .create(this.localBatch.CreatedBy)
                .setAvatar(this.localBatch.UserFile?.Endpoint ?? "");
        }
    }

    private setupPriceButton(): void {
        if (this.localBatch.StartingPrice) {
            this.priceButtonConfiguration = AuctionDetailButtonConfiguration
                .create("Prezzo partenza")
                .setPrice(this.localBatch.StartingPrice)
                .setCssClass("secondary-color");
        }
    }

    private setupTimeButton(): void {
        if (this.configuration.time) {
            this.timeButtonConfiguration = AuctionDetailButtonConfiguration
                .create("Termina tra")
                .setTime(this.configuration.time)
                .setCssClass("primary-color");
        }

        if (this.configuration.extraCSS) {
            this.extraCSSButtonConfiguration = FbGeneralButtonConfiguration
                .create("ASTA TERMINATA")
                .setStyleClass("primary-color");
        }
    }

    // Time Management
    private updateTimeDisplay(): void {
        const startDate = this.localBatch.StartDate.toString();
        const endDate = this.localBatch.EndDate.toString();
        const now = new Date().getTime();
        const start = new Date(startDate).getTime();
        const end = new Date(endDate).getTime();

        if (end < now) {
            this.setTimeAsConcluded();
        } else if (now < start) {
            this.setTimeAsNotStarted(startDate);
        } else {
            this.setTimeAsActive(end - now);
        }
    }

    private setTimeAsConcluded(): void {
        this.timeButtonConfiguration = AuctionDetailButtonConfiguration
            .create("Tempo asta:")
            .setDescription("Concluso")
            .setCssClass("secondary-color");
        this.submitButtonConfiguration?.setDisabled(true);
    }

    private setTimeAsNotStarted(startDate: string): void {
        const startDateObj = new Date(startDate);
        const formattedDate = startDateObj.toLocaleDateString("it-IT");
        const formattedTime = startDateObj.toLocaleTimeString("it-IT", {
            hour: "2-digit",
            minute: "2-digit",
        });

        this.timeButtonConfiguration = AuctionDetailButtonConfiguration
            .create("Inizio asta:")
            .setDescription(`${formattedDate} ${formattedTime}`)
            .setCssClass("secondary-color");
        this.submitButtonConfiguration?.setDisabled(true);
    }

    private setTimeAsActive(remainingMs: number): void {
        this.timeButtonConfiguration = AuctionDetailButtonConfiguration
            .create("Termina tra")
            .setTime(remainingMs / 1000)
            .setCssClass("secondary-color");
        this.submitButtonConfiguration?.setDisabled(false);
    }

    // Bid Management
    toggleBidForm(): void {
        this.showBidForm = !this.showBidForm;
        if (this.showBidForm && this.auctionCard) {
            this.scrollToElement();
        }
    }

    add(value: number): void {
        this.addPrice = value;
        this.updateCurrentOffer();
    }

    updateCurrentOffer(): void {
        const baseAmount = this.localBatch.RankingInfos?.MyAmount;
        const basePrice = (baseAmount === null || baseAmount === 0)
            ? this.localBatch.StartingPrice
            : baseAmount;

        this.currentOffer = basePrice + this.addPrice;
    }

    async onSubmit(): Promise<void> {
        this.isLoading = true;

        try {
            if (!this.validateBidInput()) {
                return;
            }

            if (this.isValidBid()) {
                await this.submitBid();
            } else {
                this.showBidError();
                this.toggleBidForm();
            }
        } catch (error) {
            this.showError('Si è verificato un errore durante l\'operazione.');
        } finally {
            this.isLoading = false;
        }
    }

    private validateBidInput(): boolean {
        if (!this.bidInputConfiguration.Control.valid && this.multipleBatch) {
            this.showError('Numero lotti inseriti non valido, riprova!');
            return false;
        }
        return true;
    }

    private isValidBid(): boolean {
        const hasValidAddress = this.form.valid || this.localBatch.RankingInfos?.Place;
        const myAmount = this.localBatch.RankingInfos?.MyAmount;

        const isValidAmount = (myAmount != null && myAmount !== 0 && this.currentOffer > myAmount) ||
                             (myAmount === 0 && this.currentOffer >= this.localBatch.StartingPrice);

        return hasValidAddress && isValidAmount;
    }

    // Semplifica submitBid() - passa true per mantenere il form aperto
    private async submitBid(): Promise<void> {
        console.log('📤 Submitting bid - Current Offer:', this.currentOffer);
        console.log('📤 Before reload - MyAmount:', this.localBatch.RankingInfos?.MyAmount);

        const param = this.createBidDTO();
        await this.rankingController.bid(param);

        const detail = this.getBidSuccessMessage();
        this.showSuccess(detail);

        // Ricarica TUTTI i dati dal backend mantenendo il form aperto
        await this.loadCompleteData(true);

        console.log('📥 After reload - MyAmount:', this.localBatch.RankingInfos?.MyAmount);
        console.log('📥 After reload - Current Offer:', this.currentOffer);
        console.log('📥 After reload - Add Price:', this.addPrice);
    }

    private createBidDTO(): RankingBidDTO {
        const param = new RankingBidDTO(
            this.localBatch.Oid,
            this.currentOffer,
            this.bidInputConfiguration.Control.value
        );

        if (this.form.valid) {
            param.PlaceOid = this.form.get('Address')?.value[0]?.value;
        }

        return param;
    }

    private getBidSuccessMessage(): string {
        const myAmount = this.localBatch.RankingInfos?.MyAmount;

        if (myAmount === 0 || myAmount === null) {
            return 'Offerta registrata con successo!';
        } else if (myAmount > 0) {
            return 'Rilancio effettuato con successo!';
        }

        return "L'operazione è stata eseguita correttamente";
    }

    private showBidError(): void {
        let detail = 'Qualcosa è andato storto, riprova.';

        if (this.currentOffer <= this.localBatch.RankingInfos?.MyAmount) {
            detail = 'L\'importo selezionato non è valido!';
        } else if (!this.form.valid && !this.localBatch.RankingInfos?.Place) {
            detail = 'Selezionare un indirizzo!';
        }

        this.showError(detail);
    }

    // Suspend Management
    suspendForm(): void {
        this.suspendeBatchForm = !this.suspendeBatchForm;
        if (this.suspendeBatchForm && this.auctionCard) {
            this.scrollToElement();
        }
    }

    async onSuspend(): Promise<void> {
        this.isLoading = true;

        try {
            const batchSusp = this.createSuspendDTO();
            await this.batchController.suspend(batchSusp);

            this.showSuccess('L\'asta è stata rimandata con successo');
            this.suspendForm();

            // Ricarica TUTTI i dati dal backend (che include il reset)
            await this.loadCompleteData();

        } catch (error) {
            this.showError('Si è verificato un errore durante l\'operazione.');
        } finally {
            this.isLoading = false;
        }
    }

    private createSuspendDTO(): BatchDTO {
        const batchSusp = new BatchDTO();
        batchSusp.Timing = this.formSusp.get('timer')?.value.value;
        batchSusp.StartDate = this.formSusp.get('date')?.value;
        batchSusp.Oid = this.localBatch.Oid;
        return batchSusp;
    }

    // Delete Management
    async onDelete(): Promise<void> {
        await this.batchController.delete(this.localBatch.Oid);
    }

    // Modal Management
    bid(): void {
        if (!this.bidInputConfiguration.Control.valid && this.multipleBatch) {
            this.showError('Numero lotti inseriti non valido, riprova!');
            return;
        }

        const modalConfig = this.createModalConfig();
        const ref = this.openBidModal(modalConfig);

        ref.onClose.subscribe((res: boolean) => {
            if (res) {
                this.onModalClose();
            }
        });
    }

    private createModalConfig(): FbSubmitModalConfiguration {
        const modalConfig = new FbSubmitModalConfiguration(
            this.localBatch.Oid,
            this.localBatch.Name,
            this.localBatch.StartingPrice,
            this.bidInputConfiguration.Control?.value ?? 1
        );

        const offer = this.localBatch.RankingInfos?.MyAmount || 0;
        if (offer > 0) {
            modalConfig.setOffer(offer);
        }

        if (this.localBatch.RankingInfos?.Place) {
            const place = this.localBatch.RankingInfos.Place;
            const address = `${place.Name || 'Nome non disponibile'}, ${place.City || 'Città non disponibile'}, ${place.PostalCode || 'CAP non disponibile'}`;
            modalConfig.setAddress(address);
        }

        return modalConfig;
    }

    private openBidModal(modalConfig: FbSubmitModalConfiguration): DynamicDialogRef {
        return this.dialogService.open(FbBatchsubmitModalComponent, {
            width: '50rem',
            contentStyle: {
                "max-height": "500px",
                "overflow": "auto",
                "border-radius": "12px"
            },
            breakpoints: {
                '1199px': '75vw',
                '575px': '90vw'
            },
            modal: true,
            data: { modalConfig },
            closable: false,
        });
    }

    onModalClose(): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Rilancio avvenuto con successo!',
            detail: 'Grazie per aver rilanciato questa Asta, buona fortuna!'
        });
        this.cdr.detectChanges();
    }

    // UI Helper Methods
    getSubHeader(): string {
        return [
            'Peso lotto:',
            this.localBatch.ProductQuantity,
            this.getMeasuringUnitTranslation(this.localBatch.MeasuringUnit) + ',',
            'Prezzo U/M:',
            this.localBatch.PriceByMeasuringUnit,
            '€,',
            'Disponibilità:',
            this.localBatch.Quantity,
            'lott' + (this.multipleBatch ? 'i' : 'o')
        ].join(' ');
    }

    generateSubtitle(): { text: string; totalPrice: number; pricePerLot: number; quantity: number } {
        const quantity = this.bidInputConfiguration.Control.value;
        const rankingInfo = this.localBatch.RankingInfos;

        let pricePerLotBase = this.localBatch.StartingPrice;
        if (rankingInfo && rankingInfo.MyAmount !== undefined && rankingInfo.MyAmount !== 0) {
            pricePerLotBase = rankingInfo.MyAmount;
        }

        const pricePerLot = pricePerLotBase + this.addPrice;
        const totalPrice = pricePerLot * quantity;

        return {
            text: 'Stai per offrire',
            totalPrice: totalPrice,
            pricePerLot: pricePerLot,
            quantity: quantity,
        };
    }

    // Translation Methods
    getMeasuringUnitTranslation(status: MeasuringUnitEnum): string {
        const translations = {
            [MeasuringUnitEnum.Box]: 'Scatole',
            [MeasuringUnitEnum.Package]: 'Conf.',
            [MeasuringUnitEnum.Weight]: 'Kg',
            [MeasuringUnitEnum.Litre]: 'Litri',
        };
        return translations[status] || '';
    }

    getBatchAvailabilityStatusTranslation(status: BatchStatusEnum): string {
        const translations = {
            [BatchStatusEnum.Suspended]: 'Sospesa',
            [BatchStatusEnum.Cancelled]: 'Cancellata',
            [BatchStatusEnum.Active]: 'Attiva',
            [BatchStatusEnum.Closed]: 'Chiusa',
            [BatchStatusEnum.Approval]: 'In approvazione',
            [BatchStatusEnum.CancelledBySystem]: 'Cancellata',
        };
        return translations[status] || 'Stato sconosciuto';
    }

    // Utility Methods
    private scrollToElement(): void {
        setTimeout(() => {
            this.auctionCard.nativeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
        }, 0);
    }

    private showSuccess(detail: string): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Successo!',
            detail: detail
        });
    }

    private showError(detail: string): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Attenzione!',
            detail: detail
        });
        this.isLoading = false;
    }
}
